import { Skeleton, Slot, Heading, Anchor } from '@costar-ui/components';
import React from 'react';

var Name = function Name(props) {
  var label = props.label,
    href = props.href,
    _props$target = props.target,
    target = _props$target === void 0 ? '_blank' : _props$target,
    onNameClick = props.onNameClick,
    isLoading = props.isLoading,
    testId = props.testId;
  return isLoading ? /*#__PURE__*/React.createElement(Skeleton, {
    width: "full",
    height: "1.5",
    className: "csg-tw-skeleton-name"
  }) : label && /*#__PURE__*/React.createElement(Slot, {
    className: "csg-tw-name",
    testId: testId
  }, /*#__PURE__*/React.createElement(Heading, {
    as: "h3",
    variant: "heading-18",
    testId: testId,
    className: "wrap-anywhere"
  }, onNameClick ? /*#__PURE__*/React.createElement(Anchor, {
    variant: "primary",
    onClick: onNameClick,
    testId: "name-link",
    className: "wrap-anywhere"
  }, label) : href ? /*#__PURE__*/React.createElement(Anchor, {
    variant: "primary",
    href: href,
    target: target,
    className: "wrap-anywhere",
    testId: "name-link"
  }, label) : label));
};

export { Name };
//# sourceMappingURL=name.esm.js.map
